import * as React from 'react';
import {
  ISectionPosition,
  IDisplayGridProps,
} from '@thryveai/theme-interfaces/dist/product-card-template/template.interfaces';
import { IScreenType } from '@thryveai/theme-interfaces';

function normalizeGridRange(value: string | number): string {
  const raw = typeof value === 'string' ? value : String(value);
  const parts = raw.split('/');
  if (parts.length !== 2) return raw;
  const [startRaw, endRaw] = parts;
  const start = Number(startRaw);
  const end = Number(endRaw);
  if (Number.isFinite(start) && Number.isFinite(end) && start === end) {
    return `${start}/${start + 1}`;
  }
  return raw;
}

export const positionForScreen = (
  sectionPosition: ISectionPosition | undefined,
  screenSize: IScreenType
): IDisplayGridProps | 'hidden' | undefined => {
  if (!sectionPosition) {
    return undefined;
  }
  const position = sectionPosition[screenSize === 'mobile' ? 'mobile' : 'tablet'];
  if (position) {
    return position;
  }
  return sectionPosition.mobile;
};

export const inlineStylesFromPosition = (position: IDisplayGridProps): React.CSSProperties => {
  const gridRow = normalizeGridRange(position.row as any);
  const gridColumn = normalizeGridRange(position.column as any);

  const style: React.CSSProperties = {
    gridRow,
    gridColumn,
  };

  if (position.justify) {
    style.justifySelf = position.justify as React.CSSProperties['justifySelf'];
  }
  if (position.align) {
    style.alignSelf = position.align as React.CSSProperties['alignSelf'];
  }
  if (position.gridGap) {
    style.gap = position.gridGap;
  }
  // Skipping due to svg fixed sizes, come back to this if we need to
  // if (position.minHeight) {
  //   style.minHeight = position.minHeight;
  // }
  // if (position.maxHeight) {
  //   style.maxHeight = position.maxHeight;
  // }

  if (position.wrapContent) {
    style.display = 'flex';
    style.flexWrap = 'wrap';
    style.alignItems = 'center';
  }

  return style;
};
